var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "input-group" },
        [
          _c("div", { staticClass: "input-group-prepend" }, [
            _c(
              "div",
              { staticClass: "input-group-text" },
              [_c("ItpIcon", { attrs: { icon: "ic:baseline-cable" } })],
              1
            )
          ]),
          _vm._v(" "),
          _c("ItpFormSelect", {
            attrs: {
              name: "exchange_rate_source",
              options: _vm.options,
              valueField: "value",
              textField: "name",
              required: "",
              readonly: _vm.readonly
            },
            on: {
              input: function($event) {
                return _vm.evh_5962862420439144_input($event, {})
              }
            },
            model: {
              value: _vm.internalValue,
              callback: function($$v) {
                _vm.internalValue = $$v
              },
              expression: "internalValue"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }